/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUpRight = createReactComponent("arrow-up-right", "IconArrowUpRight", [
  ["path", { d: "M17 7l-10 10", key: "svg-0" }],
  ["path", { d: "M8 7l9 0l0 9", key: "svg-1" }]
]);

export { IconArrowUpRight as default };
//# sourceMappingURL=IconArrowUpRight.js.map
